window._ = require('lodash');

// installs itself into window
require('chart.js')
Chart.defaults.global.elements.point.pointStyle = 'line'
Chart.defaults.global.elements.line.borderColor = '#f6993f';
Chart.defaults.global.elements.line.backgroundColor = 'rgba(247, 107, 28, .15)'
Chart.defaults.global.elements.line.fill = true
